
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class SwitchField extends Vue {
  val = false;
  @Prop()
  readonly!: boolean;
}
